import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";
import { InterfaceSubMenuLink } from "@Layouts/sidebar/sidebarLinkData/interfaceManagement/InterfaceSubMenuLink";
import {FeesMenuLinks, 
  IssuerMenuLinks,
  MessageMenuLinks,
  TransactionMenuLinks} from '@Layouts/sidebar/sidebarLinkData/interfaceManagement/visaBase2';
import VisaBatchesMenuLink from './visaBase2/BatchesMenuLinks';
import Gimac_EmitterMenuLink from './gimac/EmitterMenuLinks';
import Gimac_TransactionMenuLink from './gimac/TransactionMenuLinks';
import Gimac_BatchesMenuLink from './gimac/BatchesMenuLinks';
import AcquirerMenuLink from './gimac/AcquirerMenuLinks';
import { FaCubes } from "react-icons/fa";

const URL = URLConfig.INTERFACE_MANAGEMENT.INTERFACE;


export const InterfaceMenuLink: Array<LinkItemProps> = [
  {
    name: 'Interface',
    link: URL.ROOT,
    level: 1,
    subMenu: [
      ...InterfaceSubMenuLink,
    ]
  },
  {
    name: 'VISA BASE II',
    level: 1,
    subMenu: [
      {
        name: 'Parametres',
        link: URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.PARAMETERS,
        level: 2,
      },
      {
        name: 'Transaction',
        link: URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.TRANSACTION_MENU.ROOT,
        level: 2,
        subMenu: [
          ...TransactionMenuLinks
        ]
      },
      {
        name: 'Emetteur',
        link: URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.ISSUER_MENU.ROOT,
        level: 2,
        subMenu: [
          ...IssuerMenuLinks
        ]
      },
      {
        name: 'Frais',
        link: URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.FEES_MENU.ROOT,
        level: 2,
        subMenu: [
          ...FeesMenuLinks
        ]
      },
      {
        name: 'Messages',
        link: URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.MESSAGE_MENU.ROOT,
        level: 2,
        subMenu: [
          ...MessageMenuLinks
        ]
      },
      {
        name: 'Batches',
        level: 2,
        subMenu: [
          ...VisaBatchesMenuLink
        ]
      },
    ],
  },
  {
    name: 'GIMAC',
    level: 1,
    subMenu: [
      {
        name: 'Paramètres',
        level: 2,
        link: URLConfig.INTERFACE_MANAGEMENT.GIMAC.SETTINGS
      },
      {
        name: 'Transaction',
        level: 2,
        subMenu: [
          ...Gimac_TransactionMenuLink
        ]
      },
      {
        name: 'Acquereur',
        level: 2,
        subMenu: [
          ...AcquirerMenuLink
        ]
      },
      {
        name: 'Emetteur',
        level: 2,
        subMenu: [
          ...Gimac_EmitterMenuLink
        ]
      },
      {
        name: 'Batches',
        level: 2,
        subMenu: [
          ...Gimac_BatchesMenuLink
        ]
      },
    ],
  },
];

